import { inject, Injectable } from '@angular/core';
import { API_ENDPOINT } from './utils.service';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { TaskLegend } from 'app/models/api/color';

export interface ReadLegendsResponseDto {
  tasksLegends?: TaskLegend[];
}

export interface UpdateLegendsResponseDto {
  legends: TaskLegend[];
}

@Injectable({ providedIn: 'root' })
export class LegendService {
  private readonly legendEndpoint = `${API_ENDPOINT}/legend`;

  private readonly http: HttpClient = inject(HttpClient);

  getPalette(): Observable<TaskLegend[]> {
    return this.http.get<ReadLegendsResponseDto>(`${this.legendEndpoint}`).pipe(
      map(res => res?.tasksLegends || []),
    );
  }

  updateTaskLegends(legends: { id: string; description: string }[]): Observable<UpdateLegendsResponseDto> {
    return this.http.put<UpdateLegendsResponseDto>(`${this.legendEndpoint}/all`, { legends });
  }
}
